export default __webpack_public_path__ + "static/media/success.fb8847f2.gif";